import { render, staticRenderFns } from "./autojob.vue?vue&type=template&id=4aaded8a&scoped=true"
import script from "./autojob.vue?vue&type=script&lang=js"
export * from "./autojob.vue?vue&type=script&lang=js"
import style0 from "./autojob.vue?vue&type=style&index=0&id=4aaded8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaded8a",
  null
  
)

export default component.exports